import styled from "styled-components";

export const ReviewTextContainer = styled.div`
  display: flex;
  border-radius: 6px;
  background-color: #f3f6f9;
  padding: 8px 13px;
  color: ${props => props.disabled ? "#cccccc" : "#3f4254"};
  font-size: 14px;
`;

export const ReviewLabelContainer = styled.div`
  padding: 6px 8px;
  display: flex;
  align-items: center;
  word-break: break-word;
`;

export const ReviewFileContainer = styled.div`
  box-shadow: 1px 2px 2px #c1c1c1;
  padding: 5px 5px;
  border: 1px solid #c1c1c1;
  border-radius: 4px;
  width: 50%;
  display: flex;
  justify-content: left;
  align-items: center;
  word-break: break-all;
  max-width: fit-content; 
  min-width: 100%;
`;

export const FormFileContainer = styled.div`
  box-shadow: 1px 2px 2px #c1c1c1;
  padding: 10px 5px;
  border: 1px solid #c1c1c1;
  border-radius: 4px;
  width: 50%;
  display: flex;
  justify-content: left;
  align-items: center;
  word-break: break-all;
  max-width: fit-content; 
  min-width: 50%;
`;

export const FormCountrySelectItemContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
`;

export const UnAcceptedPageContent = styled.div`
  background-color: #ededed;
  padding: 20px;
  overflow-y: auto;
  height: calc(100vh - 64px);
  box-sizing: border-box;
`;

export const MyAccountsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const FlexBoxColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 10px;
`;

export const StatusBar = styled.div`
  background-color:  ${props => props.active === undefined ? "#6c757d" : props.active ? "#198754" : "#ffc107"};
  border-radius: 50%;
  padding: 8px 4px;
  margin: 4px 0;
  width: 16px;
  box-shadow: ${props => props.active === undefined
    ? "0px 0px 5px 2px #68686c" : props.active
      ? "0px 0px 5px 2px darkslategrey"
      : "0px 0px 5px 2px darkorange"
  };
`;

export const MenuHeadear = styled.div`
  text-align: center;
  color: lightslategray;
  font-weight: 200;
  border-bottom: 1px solid lightgray;
  padding-bottom: 6px;  
`;

export const BadgeContainer = styled.div`
  display: flex;
  font-size: 0.75rem;
  color: rgba(0, 0, 0, 0.54);
  margin-left: 14px;
  margin-top: 4px;
  align-items: center;
  margin-right: 14px;
  text-align: left;
  font-family: Poppins;
  font-weight: 400;
  line-height: 1.66;
`;

export const CustomBadge = styled.span`
  width: 16px;
  height: 16px;
  border-radius: 10px;
  background-color: #ffc107;
  text-align: center;
  margin-left: 5px;
  color: white;
`;

export const CustomBorderedContainer = styled.div`
  padding: 10px 0;
  border-bottom-color: lightgray;
  border-bottom-style: solid;
  border-bottom-width: 1px;
  margin: 5px 0;
  position: relative;
`;

export const TotalPointReviewBadge = styled.div`
  background-color: #ffc107;
  border-radius: 30px;
  border: 1px solid #ffc107;
  margin: 5px;
  padding: 5px;
  color: white;
`;

export const CTAButton = styled.div`
  width: 180px;
  height: 180px;
  text-align: center;
  padding: 10px 10px 20px 10px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 14px;
  justify-self:  center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #e8e8e8;
  box-shadow: 2px 2px 2px lightgrey;
  &:hover {
    // width: 190px;
    // height: 170px;
    transform: scale(1.1);
    color: #688ff5;
    box-shadow: 1px 1px 4px lightgrey;
    transition: 300ms;
  }
`;

export const ExistGrades = styled.div.attrs((gradePhoto => gradePhoto))`
  width: 200px;
  height: 200px;
  line-height: 200px;
  text-align: center;
  border-radius: 25px;
  cursor: pointer;
  font-size: 30px;
  color: #fff;
  background: url(${(gradePhoto) => gradePhoto.gradePhoto});
  background-size: contain;
  background-color: #5843c9;
  box-shadow: 2px 2px 2px lightgrey;
  margin-bottom: 10px;
`;

export const GradeCardContainer = styled.div`
  border: 1px solid gray;
  width: 100%;
  height: 100%;
  border-radius: 6px;
  padding: 10px;
  justify-self: center;
  color: white;
  background-image: url("/media/bg/bg-1.jpg");
  box-shadow: 2px 2px 1px lightgrey;
  background-position: center; 
  background-repeat: no-repeat;
  background-size: cover;
  opacity: ${props => props.opacity ? 1 : 0.6};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const CustomAnchor = styled.div`
  font-size: 10px; 
  cursor: pointer;
  &:hover {
    color: black;
    transition: 200ms;
  }
`;

export const FacilityGroupCard = styled.div`
  border: 1px solid gray;
  margin-bottom: 25px;
  border-radius: 6px;
  padding: 10px;
  justify-self: center;
  color: white;
  background: #6200ffc2;
  box-shadow: 2px 2px 1px lightgrey;
  background-position: center; 
  background-repeat: no-repeat;
  background-size: cover;
  opacity: ${props => props.opacity ? 1 : 0.6};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const AdvisorGroupCard = styled.div`
  border: 1px solid gray;
  border-radius: 6px;
  padding: 25px 0px;
  justify-self: center;
  color: white;
  background: #6200ffc2;
  box-shadow: 2px 2px 1px lightgrey;
  background-position: center; 
  background-repeat: no-repeat;
  background-size: cover;
  opacity: ${props => props.opacity ? 1 : 0.8};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;
  text-align: center;
  &:hover {
    opacity: 1;
    transition: 200ms;
  }
`;